// ============================================
// ONBOARDING STEP MODELS
// Based on iOS OnboardingFlowView.swift
// ============================================

export enum OnboardingStep {
  CreateVenue = 0,
  CreateUser = 1,
  CreateDomain = 2,
  DNSCreated = 3,
  CPanelDomainCreated = 4,
  WPDatabaseCreated = 5,
  WPDatabaseUserCreated = 6,
  WPAssignedPrivilegesToDatabaseUser = 7,
  WPCoreDownloaded = 8,
  WPConfigCreated = 9,
  WPCoreInstalled = 10,
  WPPermalinksUpdated = 11,
  WoocommerceInstalled = 12,
  ProductPermalinkInstalled = 13,
  WoocommerceCountryUpdated = 14,
  WoocommerceCurrencyUpdated = 15,
  WPPricesFlushed = 16,
  WoocommerceAPIKeyCreated = 17,
  ShopReadyToUse = 18,
  CreateMenu = 19,
  EditMenu = 20,
  SetLanguages = 23,
  Finished = 24,
  LoginFailed = 25
}

export enum ShopStatus {
  Active = 1,
  Inactive = 2,
  InTrial = 3
}

export interface OnboardingStepResponse {
  shop: Client;
  step: number;
}

export interface Client {
  id?: number;
  name?: string;
  city?: string;
  countryId?: number;
  currencyId?: number;
  secondCurrencyId?: number;
  url?: string;
  consumerKey?: string;
  secret?: string;
  wordpressAdmin?: string;
  wordpressPassword?: string;
  retryOnboarding?: boolean;
  languages?: Language[];
  currency?: string;
  storeType?: string;
  [key: string]: any;
}

export interface Language {
  id: number;
  code: string;
  name: string;
  isDefault?: boolean;
}
